export const defaultRiskRules =  [
    {
        minRisk: 1,
        maxRisk: 9,
        times: [],
        onArrivalTravel: false,
        onArrivalAccommodation: false,
        onDepartureTravel: false,
        onDepartureAccommodation: false,
        timeGracePeriod: 60,
        arrivalGracePeriod: 60,
        departureGracePeriod: 60,
    }
]